<template>
  <div>
    <ExpertHeader :image="entry.image ? entry.image[0] : null">
      <div>
        <div class="fluid-xs leading-tightest text-br-green">{{ $t('experts.blackrollExpert') }}</div>
        <h1 class="fluid-4xl leading-none mt-4 text-white">{{ entry.title }}</h1>
        <div class="fluid-xs leading-tightest mt-4 text-white">{{ entry.jobTitle }}</div>
      </div>
    </ExpertHeader>
    <ContentBlocks :entry="entry" />
  </div>
</template>
<script>
import gql from 'graphql-tag';
import ExpertHeader from '@/components/experts/ExpertHeader';
import ContentBlocks from '@/components/common/ContentBlocks';
import { ContentBlocksMatrixFragment } from '@/components/common/ContentBlocksMatrixFragment.js';
import { generateSchema as generateExpertPageSchema } from '@/components/expert/ExpertPage.schema';
import { useAppStore } from '@/stores/app';

export const ExpertPageFragment = gql`
  fragment ExpertPageFragment on expert_Entry {
    title
    jobTitle
    teaserText
    seoTopics
    image {
      url
      title
    }
    contentBlocks {
      ...ContentBlocksMatrixFragment
    }
  }
  ${ContentBlocksMatrixFragment}
`;

export default defineNuxtComponent({
  name: 'ExpertPage',
  components: { ExpertHeader, ContentBlocks },
  props: {
    entry: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const { registerComponentSchema, DEFAULT_PAGE_SCHEMA } = useSchema();

    // Generate schema once on mount
    if (props.entry) {
      const appStore = useAppStore();
      const siteIdentity = appStore.siteIdentity || {};
      const schema = generateExpertPageSchema(props.entry, siteIdentity);
      registerComponentSchema(schema, DEFAULT_PAGE_SCHEMA);
    }
  },
});
</script>
